import './underConstruction.scss'

function UnderConstruction() {
  // const { t } = useTranslation()
  const nowFullYear = new Date().getFullYear()
  
  return (
    <div className='page-underConstruction'>
      <div className='underConstruction-content'>
        <div className='content-text'>
          <div className='text main'>Under</div>
          <div className='text second'>Construction</div>
        </div>
        <div className='content-bar'>
          <div className='bar'>
            <div className='bar-inner' style={{ width: '64%' }}/>
          </div>
          <div className='bar-info'>
            <div>1%</div>
            <div>100%</div>
          </div>
        </div>
      </div>
      <div className='underConstruction-footer'>
        <div>Copyright © {nowFullYear} by dwain - All Rights Reserved</div>
      </div>

      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      <div className="cube"></div>
      

    </div>
  )
}

export default UnderConstruction
